import { FC } from 'react'
import styles from './TrophyMemoryCardList.module.scss'
import { TrophyMemoryDto } from '~/modules/Trophies/Infrastructure/TrophyDetailComponentDto'
import { TrophyMemoryCard } from '~/modules/TrophyMemories/Infrastructure/Components/TrophyMemoryCard'
import { TrophyMemoryCardSkeleton } from '~/modules/TrophyMemories/Infrastructure/Components/TrophyMemoryCardSkeleton'

interface Props {
  memories: TrophyMemoryDto []
  appearance?: 'default' | 'market'
  showSkeletons?: boolean
}

export const TrophyMemoryCardList: FC<Props> = ({
  memories,
  appearance = 'default',
  showSkeletons = true,
}) => {
  const numberOfSkeletonMemories = showSkeletons ? Math.max(0, 5 - memories.length) : 0
  const skeletonMemories = Array.from(Array(numberOfSkeletonMemories).keys())
    .map((index) => (<TrophyMemoryCardSkeleton key={ index } />))

  return (
    <div
      className={ `
        ${styles.trophyMemoryCardList__container}
        ${appearance === 'market' ? styles.trophyMemoryCardList__container__market : ''}
      ` }
    >
      {
        memories.map((memory) => (
          <TrophyMemoryCard
            memoryCardDto={ memory }
            key={ memory.id }
            appearance={ appearance }
          />
        ))
      }
      { skeletonMemories }
    </div>
  )
}
